var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTickersConnectedAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8424_338412)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 20,
    r: 17,
    fill: "#9097A3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 19,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 16,
    fill: "#9097A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10L21.7611 13.447L26.5106 16.9098L24.7036 22.503L22.8779 28.0902L17 28.1L11.1221 28.0902L9.29644 22.503L7.48944 16.9098L12.2389 13.447L17 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8424_338412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTickersConnectedAccountIcon);
export default __webpack_public_path__ + "static/media/no-tickers-connected-account-icon.7b947ba9103ef8ae1a2413f0ce4411ba.svg";
export { ForwardRef as ReactComponent };